import {combineReducers} from "redux";
import fileMappingListReducer from "./list/reducer";
import fileMappingWizardReducer from "./wizard/reducer";

const fileMappingReducer = combineReducers({
  components: combineReducers({
    list: fileMappingListReducer,
    wizard: fileMappingWizardReducer
  })
});

export default fileMappingReducer;


// WEBPACK FOOTER //
// ./src/scenes/data-manager/file-mapping/reducer.js